export const ACTIVATION_STATUS = Object.freeze({
    INACTIVE: 0,
    ACTIVE: 1,
});
  